import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupTextarea } from '@zealot/ui/components/input-group';
import { cn } from '@zealot/ui/lib/utils';
import { useState } from 'react';

// gloss
type NoteComposerProps = {
  onSubmit: (body: string) => void | Promise<unknown>;
  isSubmitting?: boolean;
  disabled?: boolean;
  placeholder?: string;
  submitLabel?: string;
  submittingLabel?: string;
  rows?: number;
  label?: string;
  className?: string;
};

// gloss
export const NoteComposer = ({
  onSubmit,
  isSubmitting = false,
  disabled = false,
  placeholder = 'Add a note…',
  submitLabel = 'Add note',
  submittingLabel = 'Adding…',
  rows = 3,
  label = 'Add a note',
  className,
}: NoteComposerProps) => {
  const [draft, setDraft] = useState('');
  const trimmed = draft.trim();
  const isBusy = isSubmitting || disabled;

  const handleSubmit = async () => {
    if (!trimmed) return;
    try {
      await onSubmit(trimmed);
      setDraft('');
    } catch {}
  };

  return (
    <InputGroup className={cn(className)} data-slot="note-composer">
      <InputGroupTextarea
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        placeholder={placeholder}
        rows={rows}
        disabled={isBusy}
        aria-label={label}
        className="md:text-sm"
      />
      <InputGroupAddon align="block-end" className="justify-end">
        <InputGroupButton variant="default" size="sm" onClick={handleSubmit} disabled={isBusy || !trimmed}>
          {isSubmitting ? submittingLabel : submitLabel}
        </InputGroupButton>
      </InputGroupAddon>
    </InputGroup>
  );
};
